import React from "react";

const ReservationCancelled = () => {
  return (
    <div className="reservation-cancelled">
      <div className="reservation-cancelled__icon-wrapper">
        <div className="reservation-cancelled__icon">
          <svg viewBox="0 0 24 24" width="42" height="42" fill="currentColor">
            <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm4.59 13.17L15.17 16.59 12 13.41l-3.17 3.18-1.42-1.42L10.59 12 7.41 8.83l1.42-1.42L12 10.59l3.17-3.18 1.42 1.42L13.41 12l3.18 3.17z" />
          </svg>
        </div>
      </div>
      <h2 className="reservation-cancelled__title">Reservation annulee</h2>
      <p className="reservation-cancelled__message">
        Votre creneau a bien ete annule et n&apos;est plus bloque pour vous.
      </p>
      <p className="reservation-cancelled__sub-message">
        Il pourra desormais etre reserve par un autre client.
      </p>
    </div>
  );
};

export default ReservationCancelled;
